"use client";

import useSWR from "swr";

interface BtcPriceData {
	code: number;
	message: string;
	data: number;
	_meta?: any;
}

type TracedRequestInit = RequestInit & {
	opentelemetry?: {
		ignore?: boolean;
		propagateContext?: boolean;
	};
};

const fetcher = async (url: string): Promise<number> => {
	const response = await fetch(url, {
		opentelemetry: {
			ignore: true,
			propagateContext: false,
		},
	} satisfies TracedRequestInit);
	if (!response.ok) {
		throw new Error(`HTTP error! status: ${response.status}`);
	}

	const data: BtcPriceData = await response.json();

	if (data.code !== 0 || data.message !== "ok") {
		throw new Error("Failed to fetch BTC price");
	}

	return data.data || 0;
};

export function useBtcPrice() {
	const { data, error, isLoading } = useSWR("/api/btc-price", fetcher, {
		refreshInterval: 3000, // 3秒刷新，与API缓存一致
		revalidateOnFocus: false,
		refreshWhenHidden: false,
		refreshWhenOffline: false,
		revalidateOnReconnect: true,
		dedupingInterval: 2000,
		errorRetryCount: 3,
		errorRetryInterval: 1000,
	});

	return {
		btcPrice: data || 0,
		isLoading,
		error: error
			? error instanceof Error
				? error.message
				: "Unknown error"
			: null,
	};
}
